module.exports = __webpack_public_path__ + "static/media/vscode_small.a1f0d8b3.png";